import type { PermissionContextDto } from "@Front/Api/LeCoffreApi/SuperAdmin/RolePermissions/RolePermissions";
import { GUEST_FOLDERS_UID } from "@Front/Utils/preferredRealOfficeUidHelpers";
import { getNotaryInvitedFoldersNavActive } from "@Front/Utils/notaryInvitedFoldersNavPersistence";
import { isClientContextRoute, resolveRouteContextFamily } from "@Front/Utils/routeContextRegistry";

export function isNotaryGuestFolderJwtActive(permissionContext: PermissionContextDto | null | undefined): boolean {
	if (!permissionContext) {
		return false;
	}
	return (
		permissionContext.isGuest === true ||
		permissionContext.activeOfficeUid === GUEST_FOLDERS_UID ||
		permissionContext.globalRole?.toLowerCase().replace(/_/g, "") === "guestnotary"
	);
}

export function isNotaryInvitedFolderWorkspacePath(pathname: string | null | undefined): boolean {
	const path = pathname ?? "";
	if (!path) {
		return false;
	}
	return path === "/folders/shared" || path.startsWith("/folders/shared/");
}

export function isNotaryGuestFolderWorkspaceActive(
	permissionContext: PermissionContextDto | null | undefined,
	pathname?: string | null,
): boolean {
	if (isNotaryGuestFolderJwtActive(permissionContext)) {
		return true;
	}
	const path = pathname ?? (typeof window !== "undefined" ? window.location.pathname : "");
	if (isNotaryInvitedFolderWorkspacePath(path)) {
		return getNotaryInvitedFoldersNavActive();
	}
	return false;
}

/**
 * En contexte dossiers invités (JWT GUEST_FOLDERS), ne jamais évaluer la matrice sur le bureau hôte
 * du dossier ouvert sauf si le notaire y est réellement affilié.
 */
export function resolveOfficeScopedEntityForGuestFolderWorkspace(params: {
	permissionContext: PermissionContextDto | null | undefined;
	candidateScopedEntity: string | null | undefined;
	menuOfficeUid: string | null | undefined;
	affiliatedRealOfficeUids: string[];
}): string | null {
	const { permissionContext, candidateScopedEntity, menuOfficeUid, affiliatedRealOfficeUids } = params;
	if (!isNotaryGuestFolderJwtActive(permissionContext)) {
		return candidateScopedEntity ?? menuOfficeUid ?? null;
	}
	const candidate = candidateScopedEntity?.trim() ?? "";
	if (candidate.length > 0 && affiliatedRealOfficeUids.includes(candidate)) {
		return candidate;
	}
	return menuOfficeUid?.trim() ? menuOfficeUid : null;
}

export function isClientSessionAllowedOnPath(pathname: string | null | undefined): boolean {
	return isClientContextRoute(pathname) || resolveRouteContextFamily(pathname) === "client";
}
